module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Sign contract","signingDate":"Contract signing date"},"et":{"title":"Sign contract","signingDate":"Contract signing date"},"ru":{"title":"Sign contract","signingDate":"Contract signing date"}}')
  delete Component.options._Ctor
}
